import { Box, Container, Typography } from "@mui/material";
import { motion } from "framer-motion";
import React from "react";
import CustomButton from "../CustomButton";
import "./index.css";
import "swiper/css";
import "swiper/css/pagination";

import { ChevronRightRounded } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const AboutSection = () => {
  const navigate = useNavigate();

  const fadeInUp = {
    hidden: { opacity: 0, y: 500 },
    visible: { opacity: 1, y: 0, transition: { duration: 1 } },
  };

  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      variants={fadeInUp}
    >
      <Box
        sx={{
          width: "100vw",
          mb: "3rem",
          background: "linear-gradient(to bottom,rgb(185, 185, 185) 0%, rgba(249, 249, 249, 0) 100%)",
        }}
      >
        {/* About us section */}
        <Container
          sx={{
            display: "flex",
            /* height: { md: "60vh" }, */
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: "center",
            /* backgroundImage: `url(${backgroundimg})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center", */
          }}
        >
          <Box
            sx={{
              width: { xs: "100%", md: "50%" },
              /* height: "inherit", */
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flexstart",
              mb: { xs: 3 },
            }}
          >
            <Typography variant="h7" sx={{ mb: "1rem" }}>
              About us
            </Typography>
            <Typography variant="h2" sx={{ m: 0 }}>
              Breaking <span style={{ color: "#DB5430" }}>Barriers</span>,
              Building <span style={{ color: "#DB5430" }}>Opportunities</span>
            </Typography>
          </Box>
          <Box
            sx={{
              width: { xs: "100%", md: "45%" },
              /* height: "inherit", */
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Box height={80} sx={{ display: { xs: "none", md: "block" } }} />
            <Typography>
              EAGLE Learning aims to provide enhanced access to great learning
              experiences that enable individuals to unlock their innate
              potential. We strive to create opportunities for all children and
              youth across Africa to embark on holistic learning journeys that
              are relevant and accessible, equipping learners to be productive
              professionals who are curious, courageous, and caring contributors
              within their families and communities.
            </Typography>
            <Box>
              <CustomButton
                sx={{ my: "1rem" }}
                onClick={() => navigate("/about#our-story")}
              >
                <Typography>More about us</Typography>
                <ChevronRightRounded />
              </CustomButton>
            </Box>
          </Box>
        </Container>
      </Box>
    </motion.div>
  );
};

export default AboutSection;
